import React, { useContext, useEffect, useRef, useState } from "react";
import { Toast } from "primereact/toast";
import { AuthContext } from "../../../../Base/Context/AuthContext/AuthContext";
import { getLabel } from "../../../../Base/Services/Language/LanguageService";
import { baseLang } from "../../../../Base/Lang/BaseLang";
import { setTitlePage } from "../../../../Base/Services/Config/ConfigService";
import { getConceptoRetencion } from "../../../../API/Finanzas/Retencion/ConceptoRetencionRequest";
import { ConfigContext } from "../../../../Base/Context/ConfigContext/ConfigContext";
import AgGrid from "../../../../Base/Components/Tables/AgGrid/AgGrid";
import { Button } from "primereact/button";
import Card from "../../../../Base/Components/Card/Card";
import Loader from "../../../../Base/Components/Loader/Loader";
import ConceptoRetencionCrud from "./ConceptoRetencionCrud";

const ConceptoRetencionScreen = () => {
  const { userAuth } = useContext(AuthContext);
  const esAdminFinanzas = [1, 36].includes(userAuth?.IdRol);

  const { config } = useContext(ConfigContext);
  const toast = useRef(null);

  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [showDialog, setShowDialog] = useState(false);

  const [selected, setSelected] = useState(null);

  const getInfo = async () => {
    setLoading(true);
    let result = await getConceptoRetencion();
    setData(result);
    setLoading(false);
  };

  const ingresarEditar = (data) => {
    if (esAdminFinanzas) {
      setSelected(data);
      setShowDialog(true);
    }
  };

  const columns = [
    {
      header: "ID",
      headerEn: "ID",
      field: "IdConceptoRetencion",
      className: "XXsmall",
      frozen: true,
      hidden: userAuth?.IdRol === 1,
    },
    {
      field: "CodigoRetencion",
      header: "Código Retención",
      headerEn: "Retention Code",
      className: "small",
      frozen: true,
      onCellDoubleClicked: ({ data }) => {
        ingresarEditar(data);
      },
    },
    {
      header: "Descripción",
      headerEn: "Description",
      field: "DescripcionImpuestoRetenido",
      flex: 1,
      onCellDoubleClicked: ({ data }) => {
        ingresarEditar(data);
      },
    },
    {
      field: "Tasa%",
      header: "Tasa %",
      headerEn: "Rate %",
      className: "small",
      Format: "Porcentaje",
    },
    {
      header: "Cuenta",
      headerEn: "Account",
      field: "NombreCuenta",
      className: "XXXXlarge",
    },
    {
      header: "Artículo Español",
      headerEn: "Account",
      field: "ContenidoArticuloES",
      flex: 1,
    },
    {
      header: "Artículo Ingles",
      headerEn: "Account",
      field: "ContenidoArticuloEN",
      flex: 1,
    },
    {
      field: "IdConceptoRetencion",
      header: "",
      Format: "Botones",
      frozen: true,
      alignFrozen: "right",
      filter: false,
      hidden: esAdminFinanzas,
      Botones: [
        {
          icon: "pi pi-pencil",
          tooltip: "Editar",
          onClick: (rowData) => {
            if (rowData?.IdConceptoRetencion) {
              setSelected(rowData);
              setShowDialog(true);
            }
          },
          tooltipOptions: {
            position: "right",
          },
        },
      ],
    },
  ];

  const table = {
    Columns: columns,
    Data: data,
    showModal: () => {},
  };

  useEffect(() => {
    getInfo();
    setTitlePage(getLabel(baseLang, "Conceptos", config.language));
  }, []);

  return (
    <div>
      <Toast ref={toast} />
      <Card
        style={{ marginTop: 25 }}
        titulo={
          <div className="botones flex-wrap flex-wrap">
            <h2>{getLabel(baseLang, "Conceptos", config.language)}</h2>
            <Button
              icon="pi pi-refresh"
              tooltip="Buscar"
              onClick={() => getInfo()}
            />

            {esAdminFinanzas && (
              <Button
                icon="pi pi-plus"
                tooltip="Nuevo"
                onClick={(e) => {
                  setShowDialog(true);
                  setSelected(null);
                }}
              />
            )}
          </div>
        }
        contenido={
          <div>
            <Loader loading={loading} />
            <div style={{ height: "86vh" }}>
              <AgGrid table={table} />
            </div>
          </div>
        }
      />

      {showDialog && (
        <ConceptoRetencionCrud
          showDialog={showDialog}
          selected={selected}
          setSelected={setSelected}
          setShowDialog={setShowDialog}
          getInfo={getInfo}
        />
      )}
    </div>
  );
};

export default ConceptoRetencionScreen;
